module.exports = __webpack_public_path__ + "static/img/servicesbg4.1103643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg4.jpg
// module id = I37d
// module chunks = 1